import React from 'react';

import Breeder from './components/Breeder';
import Age from './components/Age';
import Sire from './components/Sire';
import Dam from './components/Dam';
import Trainer from './components/Trainer';
import Owner from './components/Owner';
import DamSire from './components/DamSire';
import Standing from './components/Standing';
import SireComment from './components/SireComment';

const StallionDetails = props => (
    <div className="hp-details__data">
        <div className="hp-details__section">
            <Age key="Age" {...props} />
            <Sire key="Sire" {...props} />
            <Dam key="Dam" {...props} />
            <DamSire key="DamSire" {...props} />
            <Standing key="Standing" {...props} />
        </div>
        <div className="hp-details__section">
            <SireComment key="SireComment" {...props} />
            <Breeder key="Breeder" {...props} />
            <div className="hp-details__extraData">
                <Trainer key="Trainer" {...props} hasPedigree />
                <Owner key="Owner" {...props} hasPedigree />
            </div>
        </div>
    </div>
);

export default StallionDetails;



// WEBPACK FOOTER //
// ./src/js/horse/details/StallionDetails.jsx